import { PaymentMethod, Product, ProductType } from '@logz-pkg/enums';
import { planAndBillingApiService, sessionStateService } from '@logz-pkg/frontend-services';
import { PlanInfoModel } from '@logz-pkg/models';
import { Observable } from '@logz-pkg/observable';

export class AccountPlanStateService {
  readonly accountPlan = new Observable<PlanInfoModel | undefined>();
  readonly pendingAccountPlan = new Observable<PlanInfoModel | undefined>();

  setAccountPlan = this.accountPlan.set;
  setPendingAccountPlan = this.pendingAccountPlan.set;

  fetch = async () => {
    const plan = await planAndBillingApiService.getPlan();
    const session = sessionStateService.session.get();

    // DEV-30427 When plan/v2 will support MarketPlaceAZURE replace userSummary dependency
    if (session?.userSummary?.liftrAccount) {
      plan.current.paymentMethod = PaymentMethod.MarketPlaceAZURE;

      const logAnalyticsProductIndex = plan.current.products.find(({ name }) => name === Product.LogAnalytics);

      if (logAnalyticsProductIndex) {
        logAnalyticsProductIndex.type = ProductType.OnDemand;
      }
    }

    this.accountPlan.set(plan.current);
    this.pendingAccountPlan.set(plan.pending);
  };

  clear = () => {
    this.accountPlan.set(undefined);
    this.pendingAccountPlan.set(undefined);
  };
}

export const accountPlanStateService = new AccountPlanStateService();
